import _ from 'underscore'

export default {

	namespaced: true,

	modules: {},

	state: {

		data: []

	},

	getters: {

		list: function(state) {

			return _.sortBy(state.data, 'category_name')

		},

		associated: function(state) {

			var associated = {}

			_.each(state.data, function(item) {

				associated[item.category_id] = item

			})

			return associated

		}

	},

	mutations: {

		add: function(state, items) {

			_.each(items, function(item) {

				if (!_.contains(item.category_id, _.pluck(state.data, 'category_id'))) {

					state.data.push(item)

				}

			})

		}

	},

	actions: {}

}